import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HostedTrackingConfig } from "../../ts-interfaces/hosted-tracking-config";
import { OrderInterface } from "../../ts-interfaces/order-interface";
import { StatusMasterController } from '@deliverysolutions/order-status-mapping';
import { EXPERIENCE_TYPE } from 'src/app/shared/constants/hosted-tracking-constants';

@Component({
  selector: 'ds-insurance-claim',
  templateUrl: './insurance-claim.component.html',
  styleUrls: ['./insurance-claim.component.scss']
})
export class InsuranceClaimComponent implements OnInit, OnChanges {
  @Input() order!: OrderInterface; // this is the package selected
  @Input() hostedTrackingConfig!: HostedTrackingConfig;
  insuranceClaim: { active: any; url: any; } = {active: false, url: ""};
  isInsuranceClaimVisilble!: boolean;
  insuranceClaimUrl!: string;

  ngOnInit(): void {
    this.checkInsuranceAvailable(this.order);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const order = changes.order.currentValue;
    if (order) {
      this.checkInsuranceAvailable(order);
    }
  }

  checkInsuranceAvailable(order: OrderInterface) {
    this.isInsuranceClaimVisilble = false;
    this.insuranceClaimUrl = "";
    if (!order) return;
    const experienceType = order?.orderAttributes?.experienceType;
    const isShippingOrDelivery = experienceType === EXPERIENCE_TYPE.SHIPPING || experienceType === EXPERIENCE_TYPE.DELIVERY; //experience is delivery or shipping
    const insuranceConfig = this.hostedTrackingConfig?.componentVisibility?.insuranceClaim; //insurance claim object
    const isInsured = order?.orderAttributes?.isInsured === true; //is insured
    if (!order || !isShippingOrDelivery || !insuranceConfig?.active || !isInsured) {
      return;
    }
    const ORDER_DISPATCHED_RANK = 100;
    const statusMasterController = new StatusMasterController();
    const { rank } = statusMasterController.getStatusDataByStatus(order.status) || {};
    if (rank && rank >= ORDER_DISPATCHED_RANK) { //if status greater than or equal to dispatched
      this.isInsuranceClaimVisilble = true;
      this.insuranceClaimUrl = this.hostedTrackingConfig?.componentVisibility?.insuranceClaim?.url || "";
    }
  }
}
